import {
  EarningMechanismConfigurationInput,
  EarningMechanismCreateMutationVariables,
  EarningMechanismUpdateMutationVariables,
} from '@occc/graphql';

import { Operation } from '../types';

export type CreateEarningMechanismOperationType = Operation<
  'earningMechanismCreate',
  EarningMechanismCreateMutationVariables
>;

export const makeEarningMechanismCreateOperation = (
  offerId: string,
  configuration: EarningMechanismConfigurationInput,
): CreateEarningMechanismOperationType => {
  return {
    name: 'earningMechanismCreate',
    variables: {
      input: {
        offerId,
        configuration,
      },
    },
  };
};

export type UpdateEarningMechanismOperationType = Operation<
  'earningMechanismUpdate',
  EarningMechanismUpdateMutationVariables
>;

export const makeEarningMechanismUpdateOperation = (
  earningMechanismId: string,
  configuration: EarningMechanismConfigurationInput,
): UpdateEarningMechanismOperationType => {
  return {
    name: 'earningMechanismUpdate',
    variables: {
      input: {
        id: earningMechanismId,
        configuration,
      },
    },
  };
};
